import { createContext } from "react";

export type OnboardingScreen = "none" | "banner" | "form";

export const OnboardingContext = createContext<{
  currentScreen: OnboardingScreen;
  setCurrentScreen: (screen: OnboardingScreen) => void;
}>({
  currentScreen: "none",
  setCurrentScreen: () => {},
}); 